(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["loon-colour-bar"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('loon-colour-bar')) {
    class LoonColourBar extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.loon-colour-bar__track');
        this.prev = this.querySelector('[data-direction="-1"]');
        this.next = this.querySelector('[data-direction="1"]');
        this.controller = new AbortController();
        const { signal } = this.controller;

        this.querySelectorAll('[data-direction]').forEach((button) => {
          button.addEventListener('click', () => {
            this.track.scrollBy({
              left: Number(button.dataset.direction) * this.track.clientWidth * 0.8,
              behavior: 'smooth'
            });
          }, { signal });
        });

        this.track.addEventListener('scroll', () => this.update(), { passive: true, signal });

        // The mega menu is display:none until opened, so re-measure when it becomes visible
        this.resizeObserver = new ResizeObserver(() => this.update());
        this.resizeObserver.observe(this.track);
        this.update();
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.resizeObserver?.disconnect();
      }

      update() {
        const { scrollLeft, scrollWidth, clientWidth } = this.track;
        const max = scrollWidth - clientWidth;
        this.toggleAttribute('scrollable', max > 1);
        this.prev.disabled = scrollLeft <= 1;
        this.next.disabled = scrollLeft >= max - 1;
      }
    }

    customElements.define('loon-colour-bar', LoonColourBar);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["loon-mobile-menu-tiles"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('loon-menu-tabs')) {
    class LoonMenuTabs extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));

        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.select(index));
          tab.addEventListener('keydown', (event) => {
            if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
            const direction = event.key === 'ArrowRight' ? 1 : -1;
            const next = (index + direction + this.tabs.length) % this.tabs.length;
            this.select(next);
            this.tabs[next].focus();
          });
        });

        // Theme editor: show the tab whose block is selected
        document.addEventListener('shopify:block:select', (event) => {
          const index = this.tabs.findIndex((tab) => tab.contains(event.target) || tab === event.target);
          if (index !== -1) this.select(index);
        });
      }

      select(index) {
        this.tabs.forEach((tab, i) => {
          const selected = i === index;
          tab.setAttribute('aria-selected', String(selected));
          tab.tabIndex = selected ? 0 : -1;
          const panel = this.querySelector('#' + tab.getAttribute('aria-controls'));
          if (panel) panel.hidden = !selected;
        });
      }
    }

    customElements.define('loon-menu-tabs', LoonMenuTabs);
  }
  } catch(e) { console.error(e); }
})();

})();
